import React from 'react'
import "./Checkout.css"
import Subtotal from './Subtotal'
import ProductItem from './ProductItem'
import { useSelector } from 'react-redux'
import {nanoid } from "nanoid"


function Checkout() {
    const basket = useSelector(state=> state.cart.basket)  
    const user=  useSelector(state => state.user.user)


  return (
    <div className='checkout'>
      <div className='checkout-left'>
        <img className="checkout-image" src="https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg"/>
        <div className='checkout-container'>
          <h2 className='checkout-title'>{user? ((user.slice(0,user.indexOf("@"))[0]).toUpperCase() + user.slice(1,user.indexOf("@")) + "'s"): "Your" } Shopping Basket</h2>
            {basket.map(item=> {
              return <ProductItem key={nanoid()} id={item.id} image={item.image} title={item.title} price={item.price} rating={item.rating} hideButton={false}/>
            })}


        </div>
        
      </div>
      <div className='checkout-right'>
      </div>
      <Subtotal/>
    </div>
  )
}

export default Checkout




